import PropTypes from 'prop-types';

const CalendarAppointmentType = PropTypes.shape({});

export const Appointment = PropTypes.shape({
  id: PropTypes.number,
  arrivalStart: PropTypes.string,
  arrivalEnd: PropTypes.string,
  confirmationDate: PropTypes.string,
  productConfirmation: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  pickupDate: PropTypes.string,
  selectedAssignee: PropTypes.shape({
    alt: PropTypes.bool,
    onSelect: PropTypes.func,
    name: PropTypes.string,
    jobs: PropTypes.number,
    kind: PropTypes.string,
    rating: PropTypes.string,
    appointments: PropTypes.array,
  }),
  apptType: PropTypes.string,
});

export const AppointmentType = PropTypes.shape({
  id: PropTypes.number,
  start_date: PropTypes.string,
  end_date: PropTypes.string,
  arrival_start_time: PropTypes.string,
  arrival_end_time: PropTypes.string,
  appointment_confirmation_date: PropTypes.string,
  product_confirmation_date: PropTypes.string,
  kind: PropTypes.string,
  note: PropTypes.string,
  created_at: PropTypes.string,
});

export default CalendarAppointmentType;



// WEBPACK FOOTER //
// ./client/app/shared/types/appointment.js